import { PermissionKeyEnum } from "@/const/data.const";
import { JWTPayload } from "jose";
import { z } from "zod";

export interface ITokenLoginResponseModel {
  userId: string;
  userName: string;
  role: string;
  isRoot: boolean;
  fullName: string;
  email: string;
  permissions: PermissionKeyEnum[];
  accessToken: string;
  refreshToken: string;
  accessTokenExpiresAtUtc: string;
  refreshTokenExpiresAtUtc: string;
}
export interface IConfigs {
  headLogo: string;
  footerTitle: string;
  headerTitle: string;
  applicationName: string;
  footerVersion: string;
}

export interface IUserInfoModel {
  fullName: string;
  email: string;
  permissionKeys: PermissionKeyEnum[];
  role?: string;
  isRoot?: boolean;
}
export interface IUserInfoResponseApiModel extends IUserInfoModel {}
export interface IUserPermissionResponseApiModel {
  userId: string;
  role: string;
  isRoot: boolean;
  permissions: PermissionKeyEnum[];
}
export const signInschema = z.object({
  userName: z.string().min(1, "Vui lòng nhập tên đăng nhập"),
  password: z.string().min(1, "Vui lòng nhập mật khẩu"),
  rememberMe: z.boolean().optional(),
  returnUrl: z.string().optional(),
});
export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, "Vui lòng nhập mật khẩu hiện tại"),
    newPassword: z.string().min(1, "Vui lòng nhập mật khẩu mới"),
    confirmNewPassword: z.string().min(1, "Vui lòng nhập lại mật khẩu mới"),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: "Mật khẩu xác nhận không khớp với mật khẩu mới",
    path: ["confirmNewPassword"], // Đặt lỗi vào đúng trường
  });
export type LoginRequestType = z.infer<typeof signInschema>;
export type ChangePasswordType = z.infer<typeof changePasswordSchema>;
export interface ISession {
  user: IUserInfoModel;
  accessToken: string;
  refreshToken: string;
  expiredTime: Date;
  refreshTokenExpiredTime?: Date;
}
export interface IJWTPayloadCustom extends JWTPayload {
  user?: IUserInfoModel;
}
